import { render, staticRenderFns } from "./score.vue?vue&type=template&id=339e0fa2&scoped=true&"
import script from "./score.vue?vue&type=script&lang=js&"
export * from "./score.vue?vue&type=script&lang=js&"
import style0 from "./score.vue?vue&type=style&index=0&id=339e0fa2&prod&lang=scss&scoped=true&"
import style1 from "./score.vue?vue&type=style&index=1&id=339e0fa2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339e0fa2",
  null
  
)

export default component.exports